














































import Vue from "vue";

import { isComputer } from "@/service/DeviceType";

export type PopoverMode = "info" | "delete";

export default Vue.extend({
  name: "ConfirmDialog",
  data() {
    return {
      // Einstellungen für Popover-Dialog
      popoverMode: "delete" as PopoverMode,
      popoverTitle: "",
      popoverHinweistext: "",
      showPopover: false,
      resolveFunction: null as null|Function,
      rejectFunction: null as null|Function,
    };
  },
  methods: {
    confirm(popoverMode: PopoverMode, title: string, text: string): Promise<void> {
      console.log("confirm");
      this.popoverMode = popoverMode;
      this.popoverTitle = title;
      this.popoverHinweistext = text;
      this.showPopover = true;
      return new Promise((resolve, reject) => {
        this.resolveFunction = resolve.bind(this);
        this.rejectFunction = reject.bind(this);
      });
    },

    // Behandeln von Eingabemasken/Dialog für
    // Neuanlage/Bearbeitung/Sperrung/Löschung
    popoverYes() {
      console.log("popoverYes");
      this.showPopover = false;
      if (this.resolveFunction) { this.resolveFunction(); }
    },
    popoverNoAbort() {
      console.log("popoverNoAbort");
      this.showPopover = false;
      if (this.rejectFunction) { this.rejectFunction(); }
    },
  },
});
